import * as yup from 'yup';

export const serviceShareInputCreateRequestModelValidationSchema = () => {
	return yup.object({
		distributorOrEntity: yup.string().required(),
		numberOfEmployees: yup
			.number()
			.min(0, 'Number should be greater than 0')
			.required('Please, insert value'),
		numberOfTechnicians: yup
			.number()
			.min(0, 'Number should be greater than 0')
			.test(
				'is-less-or-equal',
				'Value should be less than Number of employees',
				function (value) {
					if (value && value > 0) {
						return value < this.parent.numberOfEmployees;
					}

					return true;
				}
			)
			.required('Please, insert value'),
		fridgeTechnicians: yup.number().optional().notRequired(),
		channel: yup.string().required(),
		countryId: yup.number().required(),
		quarter: yup.string().required(),
		year: yup.number().required(),
		brandId: yup.number().required()
	});
};
